import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IActionMethodModel } from '../../entities/data-model';
import { IActionModel } from '../../entities/data-view';
import { IDataPanelViewModel } from '../../entities/view-model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-data-table-card',
  templateUrl: './data-table-card.component.html',
  styleUrls: ['./data-table-card.component.scss']
})
export class DataTableCardComponent implements OnInit {

  selectedValue = -1;
  actionsColomn: boolean = false;

  constructor(private authService: AuthService) { }

  @Input() vm: IDataPanelViewModel;
  @Input() includeAction: boolean = false;
  @Input() keyColumn: number = -1;
  @Input() showHeader: boolean = true;
  @Input() showTitle: boolean = true;
  @Input() subTitle: string = undefined;
  @Input() tableMaxHeight: number = undefined;

  @Output() actionFunc = new EventEmitter<IActionModel>();

  @Output() actionMethod = new EventEmitter<IActionMethodModel>();
  @Output() actionMethod2 = new EventEmitter<IActionMethodModel>();

  @Output() rowActionClick = new EventEmitter<IDataTableRowActionClickArg>();

  am: IActionModel = {
    
  };

  selectedAction: IActionMethodModel;

  /**
   * 
   */
   action(code: string, section: string) {
     this.am.code = code;
     this.am.section = section;
     this.am.userName = this.authService.userName();
    this.actionFunc.emit(this.am);
  }

  /**
   * 
   * @param vm 
   * @param rowCode 
   * @param actionCode 
   */
  onRowActionClick(vm: IDataPanelViewModel, rowCode: string, actionCode: string) {
    this.rowActionClick.emit({ vm: vm, rowCode: rowCode, actionCode: actionCode });
  }

  onActionClick(am: IActionMethodModel, entityCode: string) {
    am.entityCode = entityCode;
    this.actionMethod.emit(am);
  }

  ngOnInit() {
    this.selectedValue = this.vm.select && this.vm.select.selectValue ? this.vm.select.selectValue : 0;
  }

  getMobileClass(style: number) {
    if (style == 1)
      return "view view-cascade gradient-card-header sunny-morning-gradient narrower pb-0 pt-2";
    else if (style == 2)
      return "view view-cascade gradient-card-header young-passion-gradient narrower pb-0 pt-2";
    return "view view-cascade gradient-card-header blue-gradient narrower pb-0 pt-2";
  }

  getSelectedValue(vm: IDataPanelViewModel, value: any) {
    
    if (vm.select && vm.select.onSelect) {
      vm.select.onSelect(vm, value);
    }
  }

  popContent(): string {
    return 'test';
  }
}

/**
 * 
 */
export interface IDataTableRowActionClickArg {
  vm: IDataPanelViewModel;
  rowCode: string;
  actionCode: string;
}
